import { render, staticRenderFns } from "./AddCategoriesTranslations.vue?vue&type=template&id=7859d228&scoped=true&"
import script from "./AddCategoriesTranslations.vue?vue&type=script&lang=js&"
export * from "./AddCategoriesTranslations.vue?vue&type=script&lang=js&"
import style0 from "./AddCategoriesTranslations.vue?vue&type=style&index=0&id=7859d228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7859d228",
  null
  
)

export default component.exports